// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.product.ProductVersion
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

export class ProductVersion {
  static createProductVersion(major, minor, patch, snapshot, update) {
    const retVal = new ProductVersion();
    retVal.initProductVersion(major, minor, patch, snapshot, update);
    return retVal;
  }

  /** Do NOT invoke directly, instead use strongly typed createProductVersion factory method */
  constructor() {}

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadp.ProductVersion";
  }
  initFromJson(json, deserializeContext) {
    this.initProductVersion(json.major, json.minor, json.patch, json.snapshot, json.update);
  }
  initProductVersion(major, minor, patch, snapshot, update) {
    this._major = major;
    this._minor = minor;
    this._patch = patch;
    this._snapshot = snapshot;
    this._update = update;
  }
  toTSOG(result, serializeContext) {
    const retVal = result;
    retVal["major"] = this._major;
    retVal["minor"] = this._minor;
    retVal["patch"] = this._patch;
    retVal["snapshot"] = this._snapshot;
    retVal["update"] = this._update;
    return retVal;
  }
  get major() {
    return this._major;
  }
  set major(value) {
    this._major = value;
  }
  get minor() {
    return this._minor;
  }
  set minor(value) {
    this._minor = value;
  }
  get patch() {
    return this._patch;
  }
  set patch(value) {
    this._patch = value;
  }
  get snapshot() {
    return this._snapshot;
  }
  set snapshot(value) {
    this._snapshot = value;
  }
  get update() {
    return this._update;
  }
  set update(value) {
    this._update = value;
  }
}
//# sourceMappingURL=ProductVersion.js.map
